/**
 * Fuzzy multi-term search. Each term in the query must match at least one
 * of the provided field values (AND logic). Short terms (<=3 chars) require
 * word-boundary matching to avoid false positives.
 * @param {string} query - Search query (multi-word)
 * @param {string[]} fieldValues - Array of string values to search within
 * @returns {boolean}
 */
export function fuzzyMatch(query, fieldValues) {
  if (!query || !query.trim()) return true;
  const terms = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (!terms.length) return true;

  const haystack = fieldValues
    .filter(Boolean)
    .map((v) => v.toLowerCase())
    .join(" ");

  return terms.every((term) => {
    if (term.length <= 3) {
      const re = new RegExp(`(?<![a-zA-Z])${term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}`, "i");
      return re.test(haystack);
    }
    return haystack.includes(term);
  });
}
